import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'

import s from './_.module.css'

type Props = {
  totalResults: number
  pushElementToLocalStorage: (text: string) => void
  searchText: string
  assignments: Assignment[]
  closeDropdown: () => void
}

export const OrderSearchList = ({
  totalResults,
  pushElementToLocalStorage,
  searchText,
  assignments,
  closeDropdown,
}: Props): JSX.Element | null => {
  const history = useHistory()

  if (totalResults === 0) return null

  return (
    <div className={s.itemsSearchResults}>
      <div className={s.itemsResultHeader}>Orders ({totalResults})</div>
      <div className={s.itemsResultMenu}>
        {assignments?.slice(0, 3).map(item => {
          const projectTitle = item?.project?.title ?? item.project_title
          const projectId = item?.project?.id ?? item.project_id

          const itemTitle = item?.title ?? item.assignment_title
          const itemId = item?.id ?? item.assignment_id

          return (
            <button
              className={s.eachItemResult}
              key={itemId}
              onClick={() => {
                closeDropdown()
                pushElementToLocalStorage(itemTitle)
                history.push({
                  pathname: `/project/${projectId}/items`,
                  search: `?view_assignment=${itemId}&search_title=${searchText}&project_title=${projectTitle}`,
                  state: { activeAssignmentPart: 'brief' },
                })
              }}
              data-id="us_listItem"
            >
              <Icon
                icon="lucide:file-text"
                width="1rem"
                height="1rem"
                className={s.icon}
              />
              <span className={s.itemResultName}>
                <div>{item?.title ?? item.assignment_title}</div>
              </span>
            </button>
          )
        })}
        <button
          className={s.viewallResult}
          onClick={() => {
            closeDropdown()
            history.push(
              `/projects/items?item_types=assignment&search_title=${searchText}`
            )
          }}
          data-id="us_viewAllItems"
        >
          <span>View all Orders&nbsp;</span>
          <Icon icon="lucide:arrow-right" width="1rem" height="1rem" />
        </button>
      </div>
    </div>
  )
}
